// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class CloseAccountRequestMessage extends PFixMessage {
    constructor() {
        super(Message.CODE_PFIX_CLOSE_ACCOUNT_REQUEST_MESSAGE);
    }
}
